module.exports = __webpack_public_path__ + "static/aire-acondicionado-3c741deb4382ea08829af615d4d77459.jpg";